import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ReactSelect from 'react-select'

const PositionSelect = ({ dataPosition, setDataPosition }) => {
  const { t } = useTranslation()
  const [isLoading, setLoading] = useState(true)
  const handleSelect = (dataPosition) => {
    setDataPosition(dataPosition)
  }
  useEffect(() => {
    if (dataPosition?.length !== 0) {
      setLoading(false)
    }
  }, [dataPosition])

  return (
    <div>
      <ReactSelect
        closeMenuOnSelect={true}
        options={dataPosition}
        onChange={handleSelect}
        isSearchable={true}
        autosize={true}
        placeholder={t('hooks.positionSelect.placeholder')}
        noOptionsMessage={() => t('hooks.common.noResults')}
        isLoading={isLoading}
      />
    </div>
  )
}

export default PositionSelect
